// React
import React from "react";
// redux hooks
import { Controller } from "react-hook-form";
// BASE components
import BASEUtils from '../../../../../../../../../@BASE/utils/BASEUtils';
// material-ui components
import Box from "@mui/system/Box";
import Divider from '@mui/material/Divider';
// custom components
import NumberedHeading from "../../../../../../../../shared-components/forms/NumberedHeading";
import FormSectionsArray from "../../../../../../../../shared-components/forms/FormSectionArray";
import PEF2FDialogInitialPromptArray from './PEF2FDialogInitialPromptArray';
import PEF2FDialogInitialResponseArray from './PEF2FDialogInitialResponseArray';
import PEF2FDialogCorrectionPromptArray from './PEF2FDialogCorrectionPromptArray';
import PEF2FDialogCorrectionResponseArray from './PEF2FDialogCorrectionResponseArray';
// data
import { ReviewData } from "../../../../../data/Defaults";

export default function PEF2FDialogSegmentArray({control, errors, setValue, inputDir}) {

  const addObject = {
    id: BASEUtils.generateGUID(),
    review: ReviewData,
    initial_prompts: [
      {
        user: "",
        use_audio: false,
        text: "",
        cc: []
      },
    ],
    initial_responses: [
      {
        use_audio: false,
        lure_text: "",
        is_correct: false,
        feedbacks: [
          {
            user: "",
            use_audio: false,
            text: "",
            cc: []
          },
        ],
      },
    ],
    self_correction_prompts: [
      {
        user: "",
        use_audio: false,
        text: "",
        cc: []
      },
    ],
    self_correction_responses: [
      {
        use_audio: false,
        lure_text: "",
        is_correct: false,
        feedbacks: [
          {
            user: "",
            use_audio: false,
            text: "",
            cc: []
          },
        ],
      },
    ],
  }


  return (
    <>
      <FormSectionsArray 
        controlName="content.dialog_segments" 
        displayName="Dialog Segment" 
        addObject={addObject}
      >
        {({ index, control, errors }) => (
          <Box className='p-0'>
            <NumberedHeading number='1' title='Initial Prompt' instructions='Add one for each initial dialog you need.' />
            <Controller 
              control={control}
              name={`content.dialog_segments.${index}.initial_prompts`}
              render={({ field }) => <PEF2FDialogInitialPromptArray nestIndex={index} inputDir={inputDir} {...{control, errors, setValue }} />}
            />

            <Divider className="mt-16" />
            
            <NumberedHeading number='2' title='Initial Responses' instructions='Using the controls below add lures for the initial prompt.' />
            <Controller 
              control={control}
              name={`content.dialog_segments.${index}.initial_responses`}
              render={({ field }) => <PEF2FDialogInitialResponseArray nestIndex={index} inputDir={inputDir} {...{control, errors, setValue }} />}
            />

            <Divider className="mt-16" />
            
            <NumberedHeading number='3' title='Self Correction Prompt' instructions='Add one for each self correction dialog you need.' />
            <Controller 
              control={control}
              name={`content.dialog_segments.${index}.self_correction_prompts`}
              render={({ field }) => <PEF2FDialogCorrectionPromptArray nestIndex={index} inputDir={inputDir} {...{control, errors, setValue }} />}
            />

            <Divider className="mt-16" />
            
            <NumberedHeading number='4' title='Self Correction Responses' instructions='Using the controls below add lures for the Self Correction prompt.' />
            <Controller 
              control={control}
              name={`content.dialog_segments.${index}.self_correction_responses`}
              render={({ field }) => <PEF2FDialogCorrectionResponseArray nestIndex={index} inputDir={inputDir} {...{control, errors, setValue }} />}
            />
          
            <Divider className="mt-16" />
            
          </Box>
        )}
      </FormSectionsArray>
    </>
  )
}